import {
  BarChart3, Check, Copy, Link2, MousePointerClick, Plus, QrCode, ShoppingBag, Trash2, UserRound, Wallet,
} from "lucide-react";
import {
  SiFacebook, SiInstagram, SiKuaishou, SiMeta, SiTiktok, SiWhatsapp, SiYoutube,
} from "react-icons/si";

// O "G" multicolorido oficial (o SiGoogle do simple-icons e' monocromatico e o
// dono nao reconheceu como a logo do Google). Paths do G do botao de login.
const GoogleG = (props) => (
  <svg viewBox="0 0 48 48" width="18" height="18" {...props}>
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

import { reais } from "@/features/disparos/sms/api";

// Tile quadrado estilo icone de app: glifo OFICIAL da marca sobre a cor
// oficial (Kwai e' a marca internacional da Kuaishou -> SiKuaishou).
const MARCAS = {
  instagram: { Glifo: SiInstagram, fundo: "linear-gradient(45deg,#f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)", cor: "#fff" },
  tiktok:    { Glifo: SiTiktok,    fundo: "#010101", cor: "#fff" },
  facebook:  { Glifo: SiFacebook,  fundo: "#1877F2", cor: "#fff" },
  youtube:   { Glifo: SiYoutube,   fundo: "#FF0000", cor: "#fff" },
  kwai:      { Glifo: SiKuaishou,  fundo: "#FF7300", cor: "#fff" },
  google:    { Glifo: GoogleG,     fundo: "#fff",    cor: "#4285F4", borda: true },
  whatsapp:  { Glifo: SiWhatsapp,  fundo: "#25D366", cor: "#fff" },
  // Anuncio pago da Meta (Instagram/Facebook, criado no Gerenciador).
  meta_ads:  { Glifo: SiMeta,      fundo: "#0866FF", cor: "#fff" },
  rede:      { Glifo: Link2,       fundo: "var(--muted, #262b36)", cor: "currentColor" },
  influencer:{ Glifo: UserRound,   fundo: "#7C3AED", cor: "#fff" },
};

export function TileMarca({ slug }) {
  const m = MARCAS[slug] || MARCAS.rede;
  const { Glifo } = m;
  return (
    <span className={`grid place-items-center w-9 h-9 rounded-lg shrink-0 ${m.borda ? "border" : ""}`}
      style={{ background: m.fundo, color: m.cor }}>
      <Glifo className="w-4.5 h-4.5" size={18} />
    </span>
  );
}

const dataBR = (iso) => {
  const d = String(iso || "").slice(0, 10).split("-");
  return d.length === 3 ? `${d[2]}/${d[1]}/${d[0]}` : "";
};

/**
 * Card de um link de divulgacao: tile da marca, link copiavel, as TRES
 * metricas do proprio link (pedido do dono: por card, nao total) e a data de
 * criacao. `onDeletar` (so influencers) mostra a lixeira; `onQr` abre o QR Code
 * do link (26/10/2026).
 */
export default function CardLink({ tile, titulo, link, onCopiar, copiado, onDeletar, onMetricas, onQr }) {
  return (
    <div className="rounded-xl border bg-card p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2.5">
        <TileMarca slug={tile} />
        <p className="font-semibold flex-1 min-w-0 truncate">{titulo}</p>
        {onMetricas && (
          <button onClick={onMetricas} title="Ver métricas e gráficos"
            className="rounded-lg border p-2 text-muted-foreground hover:text-primary hover:border-primary transition-colors shrink-0">
            <BarChart3 className="w-3.5 h-3.5" />
          </button>
        )}
        {onDeletar && (
          <button onClick={onDeletar} title="Deletar link"
            className="rounded-lg border p-2 text-muted-foreground hover:text-destructive hover:border-destructive transition-colors shrink-0">
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      <div className="flex items-center gap-2">
        <code className="flex-1 min-w-0 truncate rounded-lg bg-muted px-2.5 py-1.5 text-xs tabular-nums">
          {link.link}
        </code>
        <button onClick={onCopiar} title="Copiar link"
          className={`rounded-lg border p-2 transition-colors shrink-0 ${
            copiado ? "border-emerald-500 text-emerald-500" : "hover:border-primary"}`}>
          {copiado ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
        </button>
        {onQr && (
          <button onClick={onQr} title="QR Code deste link" data-e2e="abrir-qr-link"
            className="rounded-lg border p-2 transition-colors shrink-0 hover:border-primary hover:text-primary">
            <QrCode className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      {/* As 3 metricas DESTE link. Cliques e pedidos lado a lado e o faturado
          numa faixa inteira embaixo (26/10/2026): em 3 colunas, "R$ 1.234.567,89"
          e até "12.345" cliques eram cortados com reticências. Nada é cortado e
          o número nunca se parte: no limite só o "R$" desce de linha. */}
      <div className="grid grid-cols-2 gap-1 mt-auto" data-e2e="metricas-link">
        {[
          { Icone: MousePointerClick, cor: "text-sky-500", valor: link.cliques.toLocaleString("pt-BR"), rotulo: "cliques" },
          { Icone: ShoppingBag, cor: "text-violet-500", valor: link.pedidos.toLocaleString("pt-BR"), rotulo: "pedidos" },
        ].map(({ Icone, cor, valor, rotulo }) => (
          <div key={rotulo} className="rounded-lg bg-muted/40 px-2 py-1.5 text-center min-w-0">
            <Icone className={`w-3.5 h-3.5 mx-auto mb-0.5 ${cor}`} />
            <p className="text-sm font-bold tabular-nums leading-tight" data-e2e={`metrica-${rotulo}`}>{valor}</p>
            <p className="text-[9px] uppercase tracking-wider text-muted-foreground">{rotulo}</p>
          </div>
        ))}
        <div className="col-span-2 rounded-lg bg-muted/40 px-2 py-1.5 text-center min-w-0">
          <Wallet className="w-3.5 h-3.5 mx-auto mb-0.5 text-emerald-500" />
          <p className="text-sm font-bold tabular-nums leading-tight" data-e2e="metrica-faturado">{reais(link.receita_centavos)}</p>
          <p className="text-[9px] uppercase tracking-wider text-muted-foreground">faturado</p>
        </div>
      </div>

      <p className="text-[10px] text-muted-foreground">Link criado em {dataBR(link.criado_em)}</p>
    </div>
  );
}

/** Card tracejado de acao ("+ Cadastrar ...") usado por redes extras e influencers. */
export function CardCadastrar({ rotulo, onClick }) {
  return (
    <button onClick={onClick}
      className="rounded-xl border-2 border-dashed p-4 min-h-[120px] flex flex-col items-center justify-center gap-2 text-sm font-medium text-muted-foreground hover:border-primary hover:text-foreground transition-colors">
      <Plus className="w-5 h-5" />
      {rotulo}
    </button>
  );
}

CardLink.Tile = TileMarca;
